import React from 'react';
import { useParams, useLocation, Navigate } from 'react-router-dom';
import ListViewLayout from '../../layout/ListViewLayout';
import DetailLayout from '../../layout/DetailLayout';
import EditLayout from '../../layout/EditLayout';

const OBJECT_NAME = 'email_layout';

/** Redirect /listview/email_layout to /setup/emaillayout */
export const RedirectEmailLayoutList = () => (
  <Navigate to="/setup/emaillayout" replace />
);

/** Redirect /view/email_layout/:id to /setup/emaillayout/:id */
export const RedirectEmailLayoutView = () => {
  const { id } = useParams();
  return <Navigate to={`/setup/emaillayout/${id}`} replace />;
};

/** Redirect /edit/email_layout or /edit/email_layout/:id to setup emaillayout create or edit */
export const RedirectEmailLayoutEdit = () => {
  const { id } = useParams();
  if (id) return <Navigate to={`/setup/emaillayout/${id}/edit`} replace />;
  return <Navigate to="/setup/emaillayout/create" replace />;
};

/**
 * Email Layout list under Setup — same as /listview/email_layout but at /setup/emaillayout.
 */
export const SetupEmailLayoutList = () => {
  const location = useLocation();
  return <ListViewLayout objectName={OBJECT_NAME} location={location} />;
};

/**
 * Email Layout detail under Setup — same as /view/email_layout/:id but at /setup/emaillayout/:id.
 */
export const SetupEmailLayoutView = ({ socket, selectedWhatsAppSetting }) => {
  const { id } = useParams();
  return (
    <DetailLayout
      objectName={OBJECT_NAME}
      id={id}
      socket={socket}
      selectedWhatsAppSetting={selectedWhatsAppSetting}
    />
  );
};

/**
 * Email Layout edit under Setup — same as /edit/email_layout/:id but at /setup/emaillayout/:id/edit.
 */
export const SetupEmailLayoutEdit = () => {
  const { id } = useParams();
  const location = useLocation();
  let sourcePage = 'listview';
  if (location.state?.sourcePage) sourcePage = location.state.sourcePage;
  else if (document.referrer?.includes('/view/')) sourcePage = 'detail';
  const searchParams = new URLSearchParams(location.search);
  const targetfield = searchParams.get('targetfield');
  const targetid = searchParams.get('targetid');
  const queryParams =
    targetfield && targetid ? { targetField: targetfield, targetId: targetid } : null;
  return (
    <EditLayout
      objectName={OBJECT_NAME}
      id={id}
      sourcePage={sourcePage}
      queryParams={queryParams}
    />
  );
};
